import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import "../../../styles/Auth/campaign.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import sendIcon from '@iconify/icons-mdi/arrow-top-right-bold-box-outline';
import { DateTime } from "luxon";
import { getData, postData, uploadFile, putData, deleteData } from "../../../webService/webservice.js";
const CampaignPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = sessionStorage.getItem("role") || localStorage.getItem("role") || "";
    const rawStoreIds = sessionStorage.getItem("storeIds") || localStorage.getItem("storeIds");
    const adminStoreIds = JSON.parse(rawStoreIds || "[]");
    const singleStoreId = sessionStorage.getItem("storeId") || localStorage.getItem("storeId") || "";
    const assignedStoreIds = adminStoreIds.length > 0 ? adminStoreIds : (singleStoreId ? [singleStoreId] : []);
    const initialStoreId = assignedStoreIds[0] || "";

    const filterAllowedStores = (storeList, currentSelectedId) => {
        if (!Array.isArray(storeList) || storeList.length === 0) return [];
        if (role === "SuperAdmin" || assignedStoreIds.length === 0) {
            return storeList;
        }
        const sId = typeof currentSelectedId === 'object' ? currentSelectedId?._id : currentSelectedId;
        return storeList.filter(store => {
            if (sId && String(store._id) === String(sId)) {
                return true;
            }
            return assignedStoreIds.some(id => String(id) === String(store._id));
        });
    };

    const [isAddCampaign, setIsAddCampaign] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);
    const [campaigns, setCamapigns] = useState([]);
    const [open, setOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const sessionToken = sessionStorage.getItem("Token") || localStorage.getItem("Token");
    const [stores, setStores] = useState([]);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editCampaignId, setEditCampaignId] = useState(null);
    const [CampaignsToDelete, setCampaignsToDelete] = useState(null);
    const [errors, setErrors] = useState({});
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);

    const sort = [[sortField, sortOrder]];

    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [selectedStoreId, setSelectedStoreId] = useState(
        initialStoreId
    );
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'S.NO',
        'Name',
        'Campaign Type',
        'Start Date',
        'End Date',
        'Status',
        'Action',
    ];
    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };
    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };
    const [formData, setFormData] = useState({
        storeId: selectedStoreId,
        campaignName: "",
        campaignType: "WhatsApp",
        description: "",
        campaignAssets: [
            { assetType: "", url: "", file: "", localFile: null, description: "" }
        ],
        startDate: "",
        endDate: "",
        status: ""
    });

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };
    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = sessionStorage.getItem("Token") || localStorage.getItem("Token");
                const data = await getData('stores/stores', { limit: 'all' }, token);
                console.log('API Full Response (stores):', data);
                const results = data?.data?.results || data?.data?.paginatedResults || data?.data?.stores || data?.data || data?.results || [];
                setStores(Array.isArray(results) ? results : []);
            } catch (error) {
                console.error("Failed to load stores", error);
            }
        };
        fetchStores();
    }, []);

    const handleAssetChange = (index, field, value) => {
        setFormData((prev) => {
            const updatedAssets = [...prev.campaignAssets];

            // If user picks a file, reset url until uploaded
            if (field === "file") {
                updatedAssets[index].file = value;   // File object before upload
                updatedAssets[index].url = "";       // Clear old URL
            } else {
                updatedAssets[index][field] = value;
            }

            return { ...prev, campaignAssets: updatedAssets };
        });
    };

    const addAsset = () => {
        setFormData((prev) => ({
            ...prev,
            campaignAssets: [
                ...prev.campaignAssets,
                { assetType: "", url: "", file: "", localFile: null, description: "" }
            ]
        }));
    };

    const removeAsset = (index) => {
        setFormData((prev) => {
            const updatedAssets = [...prev.campaignAssets];
            updatedAssets.splice(index, 1);
            return { ...prev, campaignAssets: updatedAssets };
        });
    };

    const handleAddCampaign = async (e) => {
        e.preventDefault();
        const validationErrors = validateFields(formData);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let uploadedAssets = [];

            for (const asset of formData.campaignAssets) {
                if (asset.assetType === "Link") {
                    uploadedAssets.push({
                        assetType: asset.assetType,
                        file: "",
                        url: asset.url,
                        description: asset.description,
                    });
                } else if (asset.file && userId) {
                    const uploadResult = await uploadFile(`files/upload/${userId}`, asset.file);

                    // ✅ Handle API response (either inside .data or top-level)
                    const fileInfo = uploadResult.data ? uploadResult.data : uploadResult;

                    if (uploadResult?.status === 200 && fileInfo.filename && fileInfo.uri) {
                        uploadedAssets.push({
                            assetType: asset.assetType,
                            file: fileInfo.filename,
                            url: fileInfo.uri,
                            description: asset.description,
                        });
                    } else {
                        toast.error(uploadResult?.message || "File upload failed");
                        return; // ❌ Stop campaign creation
                    }
                } else {
                    toast.error(`Missing file for asset type: ${asset.assetType}`);
                    return;
                }
            }

            // ✅ Only create campaign if uploads succeed
            const campaignData = {
                storeId: formData.storeId,
                campaignName: formData.campaignName,
                campaignType: formData.campaignType,
                description: formData.description,
                campaignAssets: uploadedAssets,
                startDate: formData.startDate,
                endDate: formData.endDate,
                status: formData.status,
            };

            console.log("📦 Sending campaign data:", campaignData);

            const response = await postData("campaigns/", campaignData, token);

            toast.success(response.message || "Campaign added successfully");

            // 🔄 Reset form
            setFormData({
                storeId: "",
                campaignName: "",
                campaignType: "WhatsApp",
                description: "",
                campaignAssets: [{ assetType: "", url: "", file: null, description: "" }],
                startDate: "",
                endDate: "",
                status: "",
            });
            setIsAddCampaign(false);
            navigate("/campaigns");
            triggerRefresh();
        } catch (error) {
            console.error("Add Campaign Error:", error);
            toast.error(error.message || "Add Campaign Failed");
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("Token");
        fetchCampaigns(currentPage, limit, searchQuery, token, selectedStoreId);
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId, sortField, sortOrder]);

    const fetchCampaigns = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            campaignName: searchQuery?.trim() || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        }
        const sid = Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }
        // if (selectedStoreId) params.storeId = selectedStoreId;
        try {
            setLoading(true);
            const response = await getData('campaigns/campaigns', params, sessionToken);
            const rawData = response?.data;
            let campaignList = [];
            let totalCount = 0;
            let totalPages = 1;

            if (Array.isArray(rawData)) {
                campaignList = rawData;
                totalCount = response?.pagination?.totalCount || response?.totalCount || campaignList.length;
                totalPages = response?.pagination?.totalPages || response?.totalPages || 1;
            } else if (rawData?.campaigns && Array.isArray(rawData.campaigns)) {
                campaignList = rawData.campaigns;
                totalCount = rawData.totalCount || campaignList.length;
                totalPages = rawData.totalPages || 1;
            } else if (rawData?.results && Array.isArray(rawData.results)) {
                campaignList = rawData.results;
                totalCount = rawData.totalCount || campaignList.length;
                totalPages = rawData.totalPages || 1;
            } else if (rawData?.[0]?.paginatedResults) {
                campaignList = rawData[0].paginatedResults || [];
                totalCount = rawData[0].totalCount || campaignList.length;
                totalPages = rawData[0].totalPages || 1;
            }

            setCamapigns(campaignList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch categories");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateCampaign = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token") || localStorage.getItem("Token");
            const userId = sessionStorage.getItem("userId") || localStorage.getItem("userId");

            let updatedAssets = [];

            if (formData.campaignAssets && Array.isArray(formData.campaignAssets)) {
                for (const asset of formData.campaignAssets) {
                    if (asset.assetType === "Link") {
                        // Links are stored directly
                        updatedAssets.push({
                            assetType: asset.assetType,
                            file: "",
                            url: asset.url,
                            description: asset.description,
                            ...(asset._id && { _id: asset._id })
                        });
                    }
                    else if (asset.localFile && userId) {
                        // New file selected → upload first
                        const uploadResult = await uploadFile(`files/upload/${userId}`, asset.localFile);

                        const fileInfo = uploadResult.data ? uploadResult.data : uploadResult;

                        if (uploadResult?.status === 200 && fileInfo.filename && fileInfo.uri) {
                            updatedAssets.push({
                                assetType: asset.assetType,
                                file: fileInfo.filename,
                                url: fileInfo.uri,
                                description: asset.description,
                                ...(asset._id && { _id: asset._id })
                            });
                        } else {
                            toast.error(uploadResult?.message || "File upload failed");
                            return;
                        }
                    }
                    else {
                        // Keep existing file as-is (not replaced)
                        updatedAssets.push({
                            assetType: asset.assetType,
                            file: asset.file || "",
                            url: asset.url || "",
                            description: asset.description,
                            ...(asset._id && { _id: asset._id })
                        });
                    }
                }
            }

            const targetStoreId =
                typeof formData.storeId === 'object' && formData.storeId?._id
                    ? formData.storeId._id
                    : formData.storeId || (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

            const campaignData = {
                storeId: targetStoreId,
                campaignName: formData.campaignName,
                campaignType: formData.campaignType,
                description: formData.description,
                campaignAssets: updatedAssets,
                startDate: formData.startDate || null,
                endDate: formData.endDate || null,
                status: formData.status,
            };

            console.log("📦 Updating campaign:", campaignData);

            const response = await putData(`campaigns/campaign/${editCampaignId}`, campaignData, token);

            if (response?.status === 200 || response?.success) {
                toast.success(response.message || "Campaign updated successfully");
                setIsPopupMode(false);
                setIsEditMode(false);
                fetchCampaigns(currentPage, limit);
                triggerRefresh();
            } else {
                toast.error(response?.message || "Failed to update campaign");
            }
        } catch (error) {
            console.error("Update Campaign Error:", error);
            toast.error(error.message || "Update Campaign Failed");
        }
    };

    const handleOpen = (campaignId) => {
        setCampaignsToDelete(campaignId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCampaignsToDelete(null);
    };

    const handleDeleteCampaign = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`campaigns/campaign/${CampaignsToDelete}`, token);
            toast.success(response.message || "Campaign deleted successfully");
            setCampaignsToDelete(null);
            fetchCampaigns(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Campaign");
        }
    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const validateFields = (data) => {
        let newErrors = {};
        if (!data.campaignName) newErrors.campaignName = "Campaign Name is required";
        if (!data.campaignType) newErrors.campaignType = "Campaign Type is required";
        if (!data.startDate) newErrors.startDate = "StartDate is required";
        if (!data.endDate) newErrors.endDate = "EndDate is required";
        if (!data.status) newErrors.status = "Status is required";
        if (!data.description) newErrors.description = "Description is required";
        return newErrors;
    }

    return (
        <div className="campaign-layout">
            <div className="campaign-content">
                <main className="campaign-main">
                    {isAddCampaign ? (
                        <div className="add-Campaign-form">
                            <h3>Add Campaign</h3>
                            <form className="Campaign-form">
                                <div className="Campaign-form-row">
                                    <div className="Campaign-form-group">
                                        <div className="Campaign-form-group">
                                            <label className="input-label">Branch Name</label>
                                            <select
                                                className="category-input"
                                                value={formData.storeId || ""}
                                                required
                                                onChange={(e) => {
                                                    const storeId = e.target.value;
                                                    setSelectedStoreId(storeId);
                                                    setFormData(prev => ({ ...prev, storeId }));
                                                    setSelectedStoreId(storeId)
                                                    window.dispatchEvent(new Event("storeChanged"));
                                                }}
                                            >
                                                <option value="">Select Branch</option>
                                                {filterAllowedStores(stores, formData.storeId).map(store => (
                                                    <option key={store._id} value={store._id}>
                                                        {store.storeName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="Campaign-form-group">
                                        <label htmlFor="campaignName" className="input-label">
                                            Campaign Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Campaign name"
                                            required
                                            className="Campaign-input"
                                            value={formData.campaignName}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, campaignName: e.target.value }))
                                            }
                                        />
                                        {errors.campaignName && <p className="field-error">{errors.campaignName}</p>}
                                    </div>
                                    <div className="Campaign-form-group">
                                        <label className="input-label">Campaign Type</label>
                                        <select
                                            id="campaignType"
                                            className="Campaign-input"
                                            value="WhatsApp"
                                            disabled
                                        >
                                            <option value='WhatsApp'>WhatsApp</option>
                                        </select>
                                        {errors.campaignType && <p className="field-error">{errors.campaignType}</p>}
                                    </div>
                                </div>
                                <div className="Campaign-form-row-campaignAsets">
                                    <label className="input-label">Campaign Assets</label>

                                    {formData.campaignAssets.map((asset, index) => (
                                        <div key={index} className="asset-block">
                                            {/* Asset Type */}
                                            <select
                                                value={asset.assetType}
                                                onChange={(e) =>
                                                    handleAssetChange(index, "assetType", e.target.value)
                                                }
                                            >
                                                <option value="">Select Asset Type</option>
                                                <option value="Image">Image</option>
                                                <option value="Video">Video</option>
                                                <option value="PDF">PDF</option>
                                                <option value="Link">Link</option>
                                                <option value="Other">Other</option>
                                            </select>
                                            {/* URL or File */}
                                            {asset.assetType === "Link" ? (
                                                <input
                                                    type="url"
                                                    placeholder="Enter URL"
                                                    value={asset.url || ""}
                                                    onChange={(e) =>
                                                        handleAssetChange(index, "url", e.target.value)
                                                    }
                                                />
                                            ) : asset.assetType === "Image" ||
                                                asset.assetType === "Video" ||
                                                asset.assetType === "PDF" ? (
                                                <>
                                                    <input
                                                        type="file"
                                                        accept={
                                                            asset.assetType === "Image"
                                                                ? "image/*"
                                                                : asset.assetType === "Video"
                                                                    ? "video/*"
                                                                    : ".pdf"
                                                        }
                                                        onChange={(e) =>
                                                            handleAssetChange(index, "file", e.target.files[0])
                                                        }
                                                    />
                                                </>
                                            ) : (
                                                <input
                                                    type="text"
                                                    placeholder="Enter Asset Info"
                                                    value={asset.url || ""}
                                                    onChange={(e) =>
                                                        handleAssetChange(index, "url", e.target.value)
                                                    }
                                                />
                                            )}

                                            {/* Description */}
                                            <input
                                                type="text"
                                                placeholder="Description"
                                                value={asset.description || ""}
                                                onChange={(e) =>
                                                    handleAssetChange(index, "description", e.target.value)
                                                }
                                            />
                                            {/* Remove Button */}
                                            {formData.campaignAssets.length > 1 && (
                                                <button type="button" onClick={() => removeAsset(index)}>
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    ))}

                                    <button type="button" className="add-asset-btn" onClick={addAsset}>
                                        Add
                                    </button>

                                </div>
                                <div className="Campaign-form-row">
                                    <div className="Campaign-form-group">
                                        <label className="input-label">Start Date</label>
                                        <input
                                            type="date"
                                            className="Campaign-input"
                                            value={formData.startDate ? formData.startDate.toISOString().slice(0, 10) : ""}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    startDate: new Date(e.target.value),
                                                })
                                            }
                                        />
                                        {errors.startDate && <p className="field-error">{errors.startDate}</p>}
                                    </div>
                                    <div className="Campaign-form-group">
                                        <label className="input-label">End Date</label>
                                        <input
                                            type="date"
                                            className="Campaign-input"
                                            value={formData.endDate ? formData.endDate.toISOString().slice(0, 10) : ""}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    endDate: new Date(e.target.value),
                                                })
                                            }
                                        />
                                        {errors.endDate && <p className="field-error">{errors.endDate}</p>}
                                    </div>
                                    <div className="Campaign-form-group">
                                        <label className="input-label">Status</label>
                                        <select
                                            id="status"
                                            className="Campaign-input"
                                            required
                                            value={formData.status}
                                            onChange={(e) => {
                                                const selectedstatusType = e.target.value;
                                                setFormData((prev) => ({ ...prev, status: selectedstatusType }))
                                            }}
                                        >
                                            <option value='' >Select Status</option>
                                            <option value='Active'>Active</option>
                                            <option value='InActive'>InActive</option>
                                        </select>
                                        {errors.status && <p className="field-error">{errors.status}</p>}
                                    </div>
                                </div>
                                <div className="Campaign-form-Row">
                                    <div className="Campaign-form-group">
                                        <label htmlFor="description" className="input-label">
                                            Description
                                        </label>
                                        <textarea
                                            placeholder="Enter description"
                                            className="Campaign-input"
                                            value={formData.description || ""}
                                            onChange={e => {
                                                let value = e.target.value;

                                                // Auto bullet on Enter
                                                if (value.endsWith("\n")) {
                                                    value += "• ";
                                                }
                                                setFormData(prev => ({ ...prev, description: value }));
                                            }}
                                            style={{ height: '100px' }}
                                        />
                                        {errors.description && <p className="field-error">{errors.description}</p>}
                                    </div>
                                </div>
                                <div className="Campaign-buttons">
                                    <button className="add-Campaign-button" type="submit" onClick={handleAddCampaign} >
                                        add Campaign
                                    </button>
                                    <button className="cancel-Campaign-button" onClick={() => setIsAddCampaign(false)}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className="campaign-kpi-grid">
                                <div className="kpi-card">
                                    <div className="kpi-icon-box" style={{ background: '#e0f2fe', color: '#0369a1' }}>
                                        <Icon icon="mdi:bullhorn-outline" />
                                    </div>
                                    <div>
                                        <div className="kpi-value">{totalCount || campaigns.length || 0}</div>
                                        <div className="kpi-label">Total Campaigns</div>
                                    </div>
                                </div>
                                <div className="kpi-card">
                                    <div className="kpi-icon-box" style={{ background: '#dcfce7', color: '#15803d' }}>
                                        <Icon icon="mdi:play-circle-outline" />
                                    </div>
                                    <div>
                                        <div className="kpi-value">
                                            {campaigns.filter(c => c.status === 'Active' || c.status === 'In Progress').length}
                                        </div>
                                        <div className="kpi-label">Active / Dispatched</div>
                                    </div>
                                </div>
                                <div className="kpi-card">
                                    <div className="kpi-icon-box" style={{ background: '#fef3c7', color: '#b45309' }}>
                                        <Icon icon="mdi:account-group-outline" />
                                    </div>
                                    <div>
                                        <div className="kpi-value">
                                            {campaigns.reduce((acc, curr) => acc + (curr.recipientCount || curr.metrics?.sent || 0), 0)}
                                        </div>
                                        <div className="kpi-label">Total Audience</div>
                                    </div>
                                </div>
                            </div>

                            <div className='Campaign-widgets'>
                                <div className="Campaign-widgets-header">
                                    <h3>Campaign Management</h3>
                                    <input
                                        type="text"
                                        placeholder="Search campaigns..."
                                        className="Campaign-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="add-Camapaign-buttons" style={{ display: 'flex', gap: '10px' }}>
                                    <button
                                        className="add-btn-Campaign"
                                        style={{ background: '#0284c7' }}
                                        onClick={() => navigate('/campaigns/templates')}
                                    >
                                        <Icon icon="mdi:file-document-multiple-outline" style={{ marginRight: '6px' }} />
                                        Template Library
                                    </button>
                                    <button
                                        className="add-btn-Campaign"
                                        onClick={() => navigate('/campaigns/create')}
                                    >
                                        + Campaign Wizard
                                    </button>
                                </div>
                            </div>

                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,   // fixed height for table container
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow>
                                            {headings.map((heading, index) => {
                                                const iscampaignName = heading === "Name";
                                                const isCampaignType = heading === "Campaign Type";
                                                const isStatus = heading === "Status";
                                                const sortKey = iscampaignName
                                                    ? "campaignName"
                                                    : isCampaignType
                                                        ? "campaignType"
                                                        : isStatus
                                                            ? "status"
                                                            : null

                                                return (
                                                    <TableCell
                                                        key={index}
                                                        sx={{
                                                            border: "none",
                                                            padding: "12px 16px",
                                                            textAlign: "center",
                                                            position: "sticky",
                                                            top: 0,
                                                            backgroundColor: "#3C0008",
                                                            zIndex: 1,
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: "4px",
                                                                color: "#ffffff",
                                                                fontSize: "14px",
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            {heading}

                                                            {sortKey && (
                                                                <span
                                                                    onClick={() => handleSort(sortKey)}
                                                                    style={{
                                                                        fontSize: "10px",
                                                                        color: "#ffffff",
                                                                        cursor: "pointer",
                                                                        marginLeft: "4px",
                                                                        userSelect: "none",
                                                                    }}
                                                                >
                                                                    {sortField === sortKey
                                                                        ? sortOrder === 1
                                                                            ? "▲"
                                                                            : "▼"
                                                                        : "▲▼"}
                                                                </span>
                                                            )}
                                                        </Typography>
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!campaigns || campaigns.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={8}>
                                                    <Typography
                                                        sx={{
                                                            textAlign: 'center',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            padding: '20px',
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        No campaigns found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            campaigns.map((campaign, index) => (
                                                <TableRow key={campaign._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{limit === "all"
                                                            ? index + 1
                                                            : (currentPage - 1) * Number(limit) + index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{campaign.campaignName}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{campaign.campaignType}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {campaign.startDate
                                                                ? DateTime.fromISO(campaign.startDate).toFormat("dd/MM/yyyy")
                                                                : "—"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {campaign.endDate
                                                                ? DateTime.fromISO(campaign.endDate).toFormat("dd/MM/yyyy")
                                                                : "—"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {campaign.status}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                const startDate = campaign.startDate
                                                                    ? new Date(campaign.startDate).toISOString().split("T")[0]
                                                                    : "";
                                                                const endDate = campaign.endDate
                                                                    ? new Date(campaign.endDate).toISOString().split("T")[0]
                                                                    : "";
                                                                const sId = typeof campaign.storeId === 'object' ? campaign.storeId?._id : campaign.storeId;
                                                                setFormData({
                                                                    campaignName: campaign.campaignName || '',
                                                                    storeId: sId || '',
                                                                    campaignType: campaign.campaignType || '',
                                                                    startDate,
                                                                    endDate,
                                                                    status: campaign.status || '',
                                                                    description: campaign.description || '',
                                                                    campaignAssets: (campaign.campaignAssets && campaign.campaignAssets.length > 0)
                                                                        ? campaign.campaignAssets.map(asset => ({
                                                                            _id: asset._id,
                                                                            assetType: asset.assetType,
                                                                            url: asset.url?.toString() || '',
                                                                            file: asset.file || null,
                                                                            description: asset.description
                                                                        }))
                                                                        : [{ assetType: "", url: "", file: null, description: "" }],
                                                                });
                                                                setEditCampaignId(campaign._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000' }}
                                                                onClick={() => handleOpen(campaign._id)}
                                                            />
                                                            <div className="tooltip-wrapper"
                                                                onClick={() => navigate(`/campaigns/analytics/${campaign._id}`)}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <Icon
                                                                    icon="mdi:chart-line"
                                                                    width={20}
                                                                    height={20}
                                                                    style={{ color: "#0284c7", cursor: "pointer" }}
                                                                />
                                                                <span className="tooltip-text">View Analytics</span>
                                                            </div>
                                                        </Box>

                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                            <div className="campaign-bottom">
                                <div className="campaign-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="campaign-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="campaign-section spacer"></div>
                                <div className="campaign-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("first")}
                                    ><Icon icon="mdi:chevron-double-left" /></button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    ><Icon icon="mdi:chevron-left" /></button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    ><Icon icon="mdi:chevron-right" /></button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("last")}
                                    ><Icon icon="mdi:chevron-double-right" /></button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    campaignName: "",
                                                    campaignType: "WhatsApp",
                                                    description: "",
                                                    campaignAssets: [
                                                        { assetType: "", url: "", file: "", description: "" }
                                                    ],
                                                    startDate: "",
                                                    endDate: "",
                                                    status: ""
                                                });
                                            }}
                                        />
                                        <div className="popup-form">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Campaign" : "Add Campaign"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateCampaign} >
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="campaignName">Campaign Name</label>
                                                        <input
                                                            type="text"
                                                            id="campaignName"
                                                            value={formData.campaignName}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    campaignName: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="input-label">Branch Name</label>
                                                        <select
                                                            className="category-input"
                                                            value={typeof formData.storeId === 'object' ? formData.storeId?._id || "" : formData.storeId || ""}
                                                            onChange={(e) =>
                                                                setFormData(prev => ({ ...prev, storeId: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select Branch</option>
                                                            {filterAllowedStores(stores, formData.storeId).map(store => (
                                                                <option key={store._id} value={store._id}>
                                                                    {store.storeName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="input-label">Campaign Type</label>
                                                        <select
                                                            id="campaignType"
                                                            className="Campaign-input"
                                                            value="WhatsApp"
                                                            disabled
                                                        >
                                                            <option value='WhatsApp'>WhatsApp</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">Start Date</label>
                                                        <input
                                                            type="date"
                                                            className="Campaign-input"
                                                            value={formData.startDate ? (typeof formData.startDate === 'string' ? formData.startDate.slice(0, 10) : new Date(formData.startDate).toISOString().slice(0, 10)) : ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    startDate: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">End Date</label>
                                                        <input
                                                            type="date"
                                                            className="Campaign-input"
                                                            value={formData.endDate ? (typeof formData.endDate === 'string' ? formData.endDate.slice(0, 10) : new Date(formData.endDate).toISOString().slice(0, 10)) : ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    endDate: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">Status</label>
                                                        <select
                                                            id="status"
                                                            className="Campaign-input"
                                                            required
                                                            value={formData.status || ""}
                                                            onChange={(e) => {
                                                                const selectedstatusType = e.target.value;
                                                                setFormData((prev) => ({ ...prev, status: selectedstatusType }))
                                                            }}
                                                        >
                                                            <option value=''>Select Status</option>
                                                            <option value='Draft'>Draft</option>
                                                            <option value='Scheduled'>Scheduled</option>
                                                            <option value='Active'>Active</option>
                                                            <option value='In Progress'>In Progress</option>
                                                            <option value='Completed'>Completed</option>
                                                            <option value='InActive'>InActive</option>
                                                            <option value='Cancelled'>Cancelled</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row-campaignAssets">
                                                    <label className="input-label">Campaign Assets</label>

                                                    {formData.campaignAssets.map((asset, index) => (
                                                        <div key={index} className="asset-block">
                                                            {/* Asset Type */}
                                                            <select
                                                                value={asset.assetType}
                                                                onChange={(e) =>
                                                                    handleAssetChange(index, "assetType", e.target.value)
                                                                }
                                                            >
                                                                <option value="">Select Asset Type</option>
                                                                <option value="Image">Image</option>
                                                                <option value="Video">Video</option>
                                                                <option value="PDF">PDF</option>
                                                                <option value="Link">Link</option>
                                                                <option value="Other">Other</option>
                                                            </select>

                                                            {/* URL or File */}
                                                            {asset.assetType === "Link" ? (
                                                                <input
                                                                    type="url"
                                                                    placeholder="Enter URL"
                                                                    value={asset.url || ""}
                                                                    onChange={(e) =>
                                                                        handleAssetChange(index, "url", e.target.value)
                                                                    }
                                                                />
                                                            ) : asset.assetType === "Image" ||
                                                                asset.assetType === "Video" ||
                                                                asset.assetType === "PDF" ? (
                                                                <>
                                                                    {asset.file && (
                                                                        <a href={asset.url} target="_blank" rel="noreferrer">
                                                                            View Uploaded {asset.assetType}
                                                                        </a>
                                                                    )}
                                                                    <input
                                                                        type="file"
                                                                        accept={
                                                                            asset.assetType === "Image"
                                                                                ? "image/*"
                                                                                : asset.assetType === "Video"
                                                                                    ? "video/*"
                                                                                    : ".pdf"
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleAssetChange(index, "file", e.target.files[0])
                                                                        }
                                                                    />
                                                                </>
                                                            ) : (
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter Asset Info"
                                                                    value={asset.url || ""}
                                                                    onChange={(e) =>
                                                                        handleAssetChange(index, "url", e.target.value)
                                                                    }
                                                                />
                                                            )}

                                                            {/* Description */}
                                                            <input
                                                                type="text"
                                                                placeholder="Description"
                                                                value={asset.description || ""}
                                                                onChange={(e) =>
                                                                    handleAssetChange(index, "description", e.target.value)
                                                                }
                                                            />

                                                            {/* Remove Button */}
                                                            {formData.campaignAssets.length > 1 && (
                                                                <button type="button" onClick={() => removeAsset(index)}>
                                                                    Remove
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}

                                                    <button type="button" className="add-asset-btn" onClick={addAsset}>
                                                        + Add
                                                    </button>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="description" className="input-label">
                                                            Description
                                                        </label>
                                                        <textarea
                                                            placeholder="Enter description"
                                                            className="Campaign-input"
                                                            value={formData.description || ""}
                                                            onChange={e => {
                                                                let value = e.target.value;

                                                                // Auto bullet on Enter
                                                                if (value.endsWith("\n")) {
                                                                    value += "• ";
                                                                }
                                                                setFormData(prev => ({ ...prev, description: value }));
                                                            }}
                                                            style={{ height: '100px' }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update Campaign" : "Add Campaign"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-secondary"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && campaigns.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more campaigns
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 380,
                                        background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                        borderRadius: "20px",
                                        boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                        p: 4,
                                        outline: "none",
                                        textAlign: "center",
                                        overflow: "hidden"
                                    }}
                                >
                                    {/* ✅ TOP ICON BADGE */}
                                    <Box
                                        sx={{
                                            width: 74,
                                            height: 74,
                                            borderRadius: "50%",
                                            background: "#3C0008",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto 16px auto",
                                            color: "#fff",
                                            fontSize: 30,
                                            boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                            animation: "deletePulse 1.6s infinite ease-in-out",
                                            "@keyframes deletePulse": {
                                                "0%": { transform: "scale(1)", boxShadow: "0 0 0 0 rgba(26,30,39,0.7)" },
                                                "70%": { transform: "scale(1.1)", boxShadow: "0 0 0 18px rgba(26,30,39,0)" },
                                                "100%": { transform: "scale(1)", boxShadow: "0 0 0 0 rgba(26,30,39,0)" },
                                            },
                                        }}
                                    >
                                        🗑️
                                    </Box>

                                    {/* ✅ TITLE */}
                                    <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#2b2b2b",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Confirm Delete
                                    </Typography>

                                    {/* ✅ DESCRIPTION */}
                                    <Typography
                                        id="modal-modal-description"
                                        sx={{
                                            mt: 1.2,
                                            fontSize: 14,
                                            color: "#666",
                                            lineHeight: 1.6
                                        }}
                                    >
                                        Are you sure you want to delete this campaign?
                                    </Typography>

                                    {/* ✅ BUTTON GROUP */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2.5,
                                            mt: 3.5
                                        }}
                                    >
                                        {/* ✅ DELETE BUTTON */}
                                        <Button
                                            variant="contained"
                                            onClick={handleDeleteCampaign}
                                            className="add-Product-button"
                                        >
                                            Yes, Delete
                                        </Button>

                                        {/* ✅ CANCEL BUTTON */}
                                        <Button
                                            variant="outlined"
                                            onClick={handleClose}
                                            className="cancel-Product-button"
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )}
                </main >
            </div >
        </div >
    );
};

export default CampaignPage;